module.exports = __webpack_public_path__ + "media/fonts/Oricons-084811a5db522b27ca40525da375157f.eot";